import moment from 'moment'

export function imageUrl (file) {
  return `${window.Panache.storageUrl}${file}`
}

/**
 * Button Themes
 * @return {object} settings
 */
export const buttonThemes = {
  primary: 'bg-green text-white border-green hover:bg-transparent hover:border-charcoal hover:text-charcoal focus:border-charcoal focus:text-charcoal focus:bg-transparent',
  secondary: 'bg-transparent text-charcoal border-charcoal hover:bg-green hover:border-green hover:text-white focus:bg-green focus:border-green focus:text-white',
  tertiary: 'bg-green text-white hover:border-white border-green hover:bg-transparent focus:border-white focus:bg-transparent',
  'green-to-pink': 'bg-green text-white border-green hover:bg-coral hover:border-coral hover:text-white focus:border-coral focus:text-white focus:bg-coral',
  'black-to-red': 'bg-transparent text-charcoal border-charcoal hover:border-red hover:text-red focus:border-red focus:text-red'
}

/**
 * Capitalise First Letter
 * @param {string} text
 * @return {string}
 */
export const capitaliseFirstLetter = (text) => {
  if (!text) {
    return text
  }

  return text.charAt(0).toUpperCase() + text.slice(1)
}

export const getNextWorkingDay = (days) => {
  const day = moment()

  for (let i = 0; i <= days; i++) {
    if (day === 5) {
      day.add(3, 'days')
    } else if (moment().day() === 6) {
      day.add(2, 'days')
    } else {
      day.add(1, 'days')
    }
  }

  return day.format('YYYY-MM-DD')
}
